import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { ProductType } from '../../types';
import {
  getProducts,
  getProductsByGroup,
  getProductsMainPage,
} from '../../Services/Data';
import Product from './Product';
import Navigation from './Navigation';
import { Divider } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { Link, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { T } from '../../Services/Localization';

const useStyles = makeStyles(theme => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 6),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  button: {
    margin: theme.spacing(1),
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  linkItem: {
    textAlign: 'end',
  },
  toGroupLink: {
    // textDecoration: 'none',
    color: 'inherit',
  },
}));

const Catalog: React.FC<any> = () => {
  const config = useSelector((state: RootState) => state.storeConfig.catalog);

  const { selectedGroup } = useParams();

  const classes = useStyles();

  const [goods, setGoods] = useState<ProductType[]>([]);
  const [mainPage, setMainPage] = useState<Record<string, ProductType[]>>({
    new: [],
  });
  const [search, setSearch] = useState<{ [key: string]: string }>({
    searchString: '',
  });

  const requestProducts = (selectedGroup = '', searchString = '') => {
    if (searchString) {
      getProducts(searchString).then(results => setGoods(results));
    } else if (selectedGroup) {
      getProductsByGroup(selectedGroup).then(results => setGoods(results));
    } else {
      getProductsMainPage().then(data => setMainPage(data));
    }
  };

  useEffect(() => {
    if (search.searchString.length === 0 || search.searchString.length >= 3) {
      requestProducts(selectedGroup, search.searchString);
    }
  }, [search.searchString, selectedGroup]);

  const onSearch = (e: React.ChangeEvent<{ value: string; name: string }>) => {
    const { name, value } = e.target;
    setSearch({ ...search, [name]: value });
  };

  return (
    <React.Fragment>
      <Navigation onSearch={onSearch} navButtons={config.groups} />
      <Container className={classes.cardGrid}>
        {!selectedGroup ? (
          config.groups.map(group => (
            <Grid key={group.name} container spacing={4}>
              <Grid item xs={6}>
                <Typography variant={'h6'} color={'textPrimary'}>
                  {group.title}
                </Typography>
              </Grid>
              <Grid item xs={6} className={classes.linkItem}>
                <Typography color={'textSecondary'}>
                  <Link className={classes.toGroupLink} to={'/' + group.name}>
                    {T('catalog.seeAll')}
                  </Link>
                </Typography>
              </Grid>
              {mainPage &&
                mainPage.rock &&
                mainPage[group.name].map(item => (
                  <Grid item key={item.id} xs={12} sm={6} md={3}>
                    <Product item={item} />
                  </Grid>
                ))}
              <Grid item xs={12}>
                <Divider color="secondary" variant="fullWidth" />
              </Grid>
            </Grid>
          ))
        ) : (
          <Grid container spacing={4}>
            {goods.map(item => (
              <Grid item key={item.id} xs={12} sm={6} md={3}>
                <Product item={item} />
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </React.Fragment>
  );
};

export default Catalog;
